import * as React from 'react';
import { isSignedOutSession, SessionStatus } from './sessionState';
import { canRenderProtectedApp, UserConfigurationStatus } from './userConfigurationState';

interface ISessionRouteBoundaryProps {
    sessionStatus: SessionStatus;
    userConfigurationStatus: UserConfigurationStatus;
    renderLoading: () => React.ReactNode;
    renderConfigurationError: () => React.ReactNode;
    renderSignedOutRoutes: () => React.ReactNode;
    renderProtectedRoutes: () => React.ReactNode;
}

export const SessionRouteBoundary: React.FC<ISessionRouteBoundaryProps> = ({
    sessionStatus,
    userConfigurationStatus,
    renderLoading,
    renderConfigurationError,
    renderSignedOutRoutes,
    renderProtectedRoutes,
}) => {
    if (isSignedOutSession(sessionStatus)) {
        return <>{renderSignedOutRoutes()}</>;
    }

    if (canRenderProtectedApp(sessionStatus, userConfigurationStatus)) {
        return <>{renderProtectedRoutes()}</>;
    }

    if (userConfigurationStatus === UserConfigurationStatus.FAILED) {
        return <>{renderConfigurationError()}</>;
    }

    return <>{renderLoading()}</>;
};
